import { save as saveApi } from "../../service/EvaluationService";
import { init as initApi } from "../../service/PlanningSheetService";
import { update as updateApi, checkPriorityTarget as checkPriorityTargetApi } from "../../service/PlanningSheetService";
export const PRIORITY_TARGET_REGISTERED = "PRIORITY_TARGET_REGISTERED";
export const PRIORITY_TARGET_UNREGISTERED = "PRIORITY_TARGET_UNREGISTERED";
export const SAVE_PRIORITY_TARGET_SUCCESS = "SAVE_PRIORITY_TARGET_SUCCESS";
export const SAVE_PRIORITY_TARGET_FAIL = "SAVE_PRIORITY_TARGET_FAIL";
export const PRINTING_FAIL = "PRINTING_FAIL";
export const PRINTING_RESET = "PRINTING_RESET";
export const PRIORITY_TARGET_CHECK_OK = "PRIORITY_TARGET_CHECK_OK";
export const PRIORITY_TARGET_CHECK_RESET = "PRIORITY_TARGET_CHECK_RESET";
export const PRIORITY_TARGET_CHECK_FAIL = "PRIORITY_TARGET_CHECK_FAIL";
export const init = params => dispatch => {
  initApi(params)
    .then(response => {
      dispatch({
        type: PRIORITY_TARGET_REGISTERED,
        payload: {
          subTitle: response.subTitle,
          printDate: response.printDate,
          serialNumber: response.serialNumber,
          grade: response.grade,
          classNumber: response.classNumber,
          name: response.name,
          targetSettings: response.targetSettings,
          number: response.number,
          updateTargetSettings: response.updateTargetSettings,
          priorityTargets: response.priorityTargets,
          stickerList: response.stickerList,
          gradeRange: response.gradeRange
        }
      });
    })
    .catch(error => {
      dispatch({ type: PRIORITY_TARGET_UNREGISTERED, payload: { error: error } });
    });
};

export const update = request => dispatch => {
  updateApi(request).then(response => {
    if (response.message) {
      dispatch({
        type: SAVE_PRIORITY_TARGET_FAIL,
        payload: response.message
      });
      alert(response.message);
    } else {
      dispatch({
        type: SAVE_PRIORITY_TARGET_SUCCESS,
        payload: {
          message: "保存できました！！"
        }
      });
    }
  });
};

export const saveTarget = request => dispatch => {
  saveApi(request)
    .then(response => {
      dispatch({
        type: SAVE_PRIORITY_TARGET_SUCCESS,
        payload: {
          message: response.message
        }
      });
    })
    .catch(error => {
      dispatch({
        type: SAVE_PRIORITY_TARGET_FAIL,
        payload: { error: error }
      });
    });
};

export const checkPriorityTarget = request => dispatch => {
  checkPriorityTargetApi(request)
    .then(response => {
      if (response.message) {
        var result = window.confirm(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);
        if (result) {
          dispatch({ type: PRIORITY_TARGET_CHECK_OK });
        }
      } else {
        dispatch({ type: PRIORITY_TARGET_CHECK_OK });
      }
    })
    .catch(error => {
      dispatch({
        type: PRIORITY_TARGET_CHECK_FAIL,
        payload: { error }
      });
    });
};

export const resetDownloadLink = () => dispatch => {
  dispatch({
    type: PRINTING_RESET,
    payload: {}
  });
};
